import React from 'react';
import * as Utils from "../../inc/Utils";
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select'
import {Config} from '../../Config'
import * as AwsS3 from '../../inc/AwsS3'
import {getContentIdType} from "../../inc/Utils";
import moment from "moment-timezone";

export default function ContentIdCreate() {
    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false);
    let [owner, setOwner] = React.useState('');
    let [chanel, setChanel] = React.useState('');
    let [campaign, setCampaign] = React.useState('');
    let [campaignType, setCampaignType] = React.useState('');
    let [bg, setBg] = React.useState('');
    let [contentCategory, setContentCategory] = React.useState('');
    let [contentIdType, setContentIdType] = React.useState('');
    const navigate = useNavigate();

    let [postDate, setPostDate] = React.useState('');
    let [ownerId, setOwnerId] = React.useState(null);
    let [campaignId, setCampaignId] = React.useState(null);
    let [bgId, setBgId] = React.useState(null);
    let [campaignTypeId, setCampaignTypeId] = React.useState(null);
    let [contentCategoryId, setContentCategoryId] = React.useState(null);
    let [contentIdTypeId, setContentIdTypeId] = React.useState(null);
    let [statusChecked, setStatusChecked] = React.useState(true);
    let [campaignPlaceholder, setCampaignPlaceholder] = React.useState('กำลังโหลด...');
    let [uploadFile, setUploadFile] = React.useState(false);
    let [awsS3Config, setAwsS3Config] = React.useState([]);

    let refContentDetail = React.useRef();
    let refBudget = React.useRef();
    let refPicture = React.useRef();
    let refCreator = React.useRef();

    React.useEffect(() => {
        (async function() {
            try {
                const resOwner = await Utils.getOwner({agencyId: roles.agencyId});
                setOwner(resOwner);
                const resChanel = await getChanel();
                setChanel(resChanel);
                const resCampaign = await Utils.getListSubCampaign();
                let campaignList = [];
                if(resCampaign.campaign) {
                    for(let rs of resCampaign.campaign) {
                        campaignList.push({
                            sub_campaign_id: rs.sub_campaign_id,
                            sub_campaign_name: rs.sub_campaign_name
                        });
                    }
                }
                setCampaign(campaignList);
                setCampaignPlaceholder('Select...');
                const resCampaignType = await getCampaignType();
                setCampaignType(resCampaignType);
                const resBg = await getBg();
                setBg(resBg);
                const resContentCategory = await getContentCategory();
                setContentCategory(resContentCategory);
                const reContentIdType = await getContentIdType();
                setContentIdType(reContentIdType);

                //region AWS S3
                const resAwsS3 = await AwsS3.getAwsS3();
                setAwsS3Config(resAwsS3);
                //endregion
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function getChanel() {
        const response = await fetch(Config.url.API_URL +'/api/chanel/listingName', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getCampaignType() {
        const response = await fetch(Config.url.API_URL +'/api/campaignType/listingName', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getBg() {
        const response = await fetch(Config.url.API_URL +'/api/bg/listingName', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getContentCategory() {
        const response = await fetch(Config.url.API_URL +'/api/contentCategory/listingName', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onCreate = () => {
        let budget = refBudget.current.value;
        if(!ownerId) {
            toast.error("กรุณาระบุ Owner");
        }
        else if(!postDate) {
            toast.error("กรุณาระบุ Post Date Time");
        }
        else if(!bgId) {
            toast.error("กรุณาระบุ BG");
        }
        else if(!contentCategoryId) {
            toast.error("กรุณาระบุ Content Category");
        }
        else if(budget && !Utils.validateNumber.test(budget)) {
            toast.error("กรุณาระบุ Budget เป็นตัวเลขเท่านั้น");
            refBudget.current.value = '';
            refBudget.current.focus();
        }
        else {
            let chanelIds = [];
            let checkboxes = document.getElementsByName('chanelIds[]');
            for (let i = 0; i < checkboxes.length; i++) {
                if(checkboxes[i].checked) {
                    chanelIds.push({'chanelId': checkboxes[i].value});
                }
            }
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');

                            //region AWS S3 Upload File
                            let fileName = null;
                            if(uploadFile) {
                                let fileValue = uploadFile.name;
                                let fileExt = fileValue.split('.').pop();
                                let newFilename = Utils.getFileName() + '.' + fileExt;
                                await AwsS3.uploadFile(awsS3Config, uploadFile, newFilename);
                                fileName = newFilename;
                            }
                            //endregion

                            const body = {
                                ownerId: ownerId.id,
                                postDate: postDate ? new Date(postDate) : null,
                                status: statusChecked[0].checked ? 1:0,
                                campaignId: campaignId ? campaignId.sub_campaign_id : null,
                                bgId: bgId.id,
                                campaignTypeId: campaignTypeId ? campaignTypeId.id : null,
                                contentCategoryId: contentCategoryId ? contentCategoryId.id : null,
                                contentDetail: refContentDetail.current.value,
                                budget: refBudget.current.value,
                                picture: refPicture.current.value,
                                creator: refCreator.current.value,
                                typeId: contentIdTypeId ? contentIdTypeId.id : null,
                                createdBy: userId,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                chanelIds: chanelIds,
                                fileName: fileName
                            };
                            fetch(Config.url.API_URL +'/api/contentId/create', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    updateContentId(result);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const updateContentId = (result) => {

        //region save content Id
        let contentIdRow = {
            owner: {
                code: ownerId.code
            },
            postDate: Utils.dateYMD(postDate, '-'),
            status: result.id.status ? 1:0,
            bg: {
                code: bgId.code
            },
            id: result.id.id
        };
        let contentId = Utils.contentIdGenerater(contentIdRow);
        //endregion

        const body = {
            id: result.id.id,
            contentId: contentId,
            updatedBy: userId,
            updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
        };
        fetch(Config.url.API_URL +'/api/contentId/updateCode', {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type':'application/json',
                'x-access-token': roles.accessToken
            }
        }).then(response => {
            setLoading(false);
            if(response.ok) {
                return response.json();
            }
            else {
                return response.json().then(err => Promise.reject(err));
            }
        }).then(result => {
            if(result) {
                toast.success("บันทึกข้อมูลเรียบร้อย");
                setTimeout(function () {
                    navigate('/contentId', {replace: true});
                }, 1500);
            }
        }).catch(err => {
            toast.error(err.message);
        })
    };

    let defaultChecked = false;

    const onChangeOwnerId = (obj) => setOwnerId(obj);
    const onChangePostDate = (value) => setPostDate(value);
    const onChangeCampaignId = (obj) => setCampaignId(obj);
    const onChangeCampaignTypeId = (obj) => setCampaignTypeId(obj);
    const onChangeBgId = (obj) => setBgId(obj);
    const onChangeContentCategoryId = (obj) => setContentCategoryId(obj);
    const onChangeContentIdTypeId = (obj) => setContentIdTypeId(obj);

    const onSelectFile = (e) => {
        if(e && e.target && e.target.files[0]) {
            let KB = e.target.files[0].size;
            let MB = awsS3Config.maxFileSizeMb;
            if(KB && (KB/1000000) >= MB) {
                toast.error('ขนาดไฟล์ต้องไม่เกิน ' + MB + ' MB');
                e.target.value = '';
                setUploadFile(null);
            }
            else {
                setUploadFile(e.target.files[0]);
            }
        }
    };

    let [validNumber, setValidNumber] = React.useState(true);
    const onKeyUpBudget = () => {
        if(refBudget.current.value) {
            let valid = Utils.validateNumber.test(refBudget.current.value);
            setValidNumber(valid);
            if(!valid) {
                setTimeout(function () {
                    refBudget.current.value = '';
                    setValidNumber(true);
                }, 1000);
            }
        }
        else {
            setValidNumber(true);
        }
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> ContentID</div>
                    <span className="ms-1">/</span> <span className="text-muted">Create</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="ownerId" className="form-label">Owner <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    options={owner}
                                    onChange={(event) => onChangeOwnerId(event)}
                                    value={ownerId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className="col-12">
                                <label htmlFor="postDate" className="form-label">Post Date Time <span className="text-danger">*</span></label>
                                <DatePicker
                                    selected={postDate}
                                    onChange={(date) => onChangePostDate(date)}
                                    dateFormat="yyyy-MM-dd"
                                    wrapperClassName="w-100"
                                    className="form-control" />
                            </div>
                            <div className="col-12">
                                <label htmlFor="statusx" className="form-label">Campaign Status</label>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" name="statusChecked" id="status" checked={statusChecked} onChange={e => {setStatusChecked(e.target.checked)}} />
                                    <label className="form-check-label" htmlFor="status"></label>
                                </div>
                            </div>
                            <div className="col-12">
                                <label htmlFor="campaignId" className="form-label">Campaign ID</label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    placeholder={campaignPlaceholder}
                                    options={campaign}
                                    onChange={(event) => onChangeCampaignId(event)}
                                    value={campaignId}
                                    getOptionValue={(option) => `${option.sub_campaign_id}`}
                                    getOptionLabel={(option) => `${option.sub_campaign_id} : ${option.sub_campaign_name}`}
                                />
                            </div>
                            <div className="col-12">
                                <label htmlFor="bgId" className="form-label">BG <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    options={bg}
                                    onChange={(event) => onChangeBgId(event)}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className="col-12">
                                <label htmlFor="campaignTypeId" className="form-label">Brand/Zone/Project (Product Type)</label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    options={campaignType}
                                    onChange={(event) => onChangeCampaignTypeId(event)}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className="col-12">
                                <label htmlFor="contentCategoryId" className="form-label">Content Category <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    options={contentCategory}
                                    onChange={(event) => onChangeContentCategoryId(event)}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className="col-12">
                                <label htmlFor="contentDetail" className="form-label">Content Detail</label>
                                <textarea className="form-control" id="contentDetail" ref={refContentDetail} maxLength={2000} rows={4}></textarea>
                            </div>
                            <div className="col-12">
                                <label htmlFor="budget" className="form-label">Budget</label>
                                <input type="text" className="form-control" id="budget" ref={refBudget} maxLength={250} onKeyUp={onKeyUpBudget} />
                                <p className={!validNumber ? 'text-danger mb-0 small':'d-none'}>ระบุตัวเลขเท่านั้น</p>
                            </div>
                            <div className="col-12">
                                <label htmlFor="chanel" className="form-label">Channel</label>
                                {
                                    chanel.length <= 0 ? (<p>ไม่พบ Channel</p>) :
                                        chanel.map((row, index) => {
                                            let chkId = 'chanelCheck' + row.id;
                                            return (
                                                <div key={index} className="form-check ms-2">
                                                    <input className="form-check-input" name="chanelIds[]" type="checkbox" value={row.id}
                                                           id={chkId} onClick={e => {defaultChecked = e.target.checked;}} />
                                                    <label className="form-check-label" htmlFor={chkId}>
                                                        {row.name}
                                                    </label>
                                                </div>);
                                        })
                                }
                            </div>
                            <div className="col-12">
                                <label htmlFor="picture" className="form-label">Picture Url</label>
                                <input type="text" className="form-control" id="picture" ref={refPicture} maxLength={250} />
                            </div>
                            <div className={"col-12" + (awsS3Config.status===1 ? '':' d-none')}>
                                <label htmlFor="uploadFile" className="form-label">Upload File</label>
                                <div className="input-group">
                                    <input type="file" className="form-control" id="uploadFile" onChange={(e) => {onSelectFile(e)}} accept={awsS3Config.allowFileExtension} />
                                </div>
                                <p className="text-danger mt-1">
                                    ขนาดไฟล์ต้องไม่เกิน {awsS3Config.maxFileSizeMb} MB<br />
                                    ประเภทไฟล์ที่รองรับ {awsS3Config.allowFileExtension}
                                </p>
                            </div>
                            <div className="col-12">
                                <label htmlFor="contentIdTypeId" className="form-label">Type</label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    options={contentIdType}
                                    onChange={(event) => onChangeContentIdTypeId(event)}
                                    value={contentIdTypeId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className="col-12 mb-3">
                                <label htmlFor="creator" className="form-label">Creator</label>
                                <input type="text" className="form-control" id="creator" ref={refCreator} maxLength={250} />
                            </div>
                            <div className="col-12">
                                <button type="button" className="btn btn-primary" onClick={onCreate}><span
                                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                <NavLink className="btn btn-sm btn-light ms-2" to='/contentId'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                <Toaster position="bottom-right" />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 